import './index.css';
					 
import { getAuth} from "firebase/auth";
import React, { useState, useEffect, useMemo } from 'react';
import { 
  ClipboardList, Package, Settings, Plus, Search, AlertCircle, 
  CheckCircle2, XCircle, Clock, TrendingUp, Save, Trash2, 
  MoreHorizontal, ChevronRight, User, Activity, History, LogIn, Database,
  Calendar, Users, Filter, Layers, Edit2, Eraser, Eye, EyeOff
} from 'lucide-react';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";


import { 
  
  signInAnonymously, 
  signInWithCustomToken,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
  signOut
} from 'firebase/auth';
import { 
  getFirestore, 
  collection, 
  doc, 
  getDoc,
  setDoc,
  addDoc, 
  updateDoc, 
  deleteDoc,
  onSnapshot, 
  query, 
  orderBy, 
  serverTimestamp 
} from 'firebase/firestore';

// --- Firebase Configuration & Initialization ---
const firebaseConfig = {
  apiKey: "AIzaSyB5WS6C3RfMXVDHj4B12YCIEuIEgXVNapE",
  authDomain: "dental-lab-tracker-fc257.firebaseapp.com",
  projectId: "dental-lab-tracker-fc257",
  storageBucket: "dental-lab-tracker-fc257.firebasestorage.app",
  messagingSenderId: "273924591066",
  appId: "1:273924591066:web:2b6d397790fed7775284e3",
  measurementId: "G-0FR0XC69GW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const appId ='dental-lab-tracker';

const allowedEmails = [
  "wlhunag@gmail.com", 
  "smile6589988@gmail.com",
  "pny111000@gmail.com",
  "kellyhung00@gmail.com" // 龍哥的信箱
];

// 外部的 handleLogin (目前看起來像是保留邏輯，主要登入邏輯在元件內)
const handleLoginCheck = (user) => {
  if (allowedEmails.includes(user.email)) {
    console.log("歡迎進入假牙追蹤系統");
    // 進入系統邏輯
  } else {
    alert("抱歉，您沒有存取權限。");
    const auth = getAuth();
    signOut(auth); // 強制登出
  }
};

// --- Initial Data (Removed Tools/Burs) ---
const INITIAL_MATERIALS = [
  // --- PMMA ---
  { brand: 'PMMA', model: '雙層色樹脂盤', spec: '30mm', shade: 'A1', stock: 2, category: 'PMMA' },
  { brand: 'PMMA', model: '雙層色樹脂盤', spec: '30mm', shade: 'A2', stock: 12, category: 'PMMA' },
  { brand: 'PMMA', model: '雙層色樹脂盤', spec: '30mm', shade: 'A3', stock: 2, category: 'PMMA' },
  { brand: 'PMMA', model: '牙齦色樹脂盤', spec: '25mm', shade: '2S', stock: 10, category: 'PMMA' },
  { brand: 'PMMA', model: '牙齦色樹脂盤', spec: '25mm', shade: '2ST', stock: 3, category: 'PMMA' },
  { brand: 'PMMA', model: '牙齦色樹脂盤', spec: '25mm', shade: '3ST', stock: 3, category: 'PMMA' },
  { brand: 'PMMA', model: '漸層樹脂盤', spec: '18mm', shade: 'A3', stock: 5, category: 'PMMA' },
  { brand: 'PMMA', model: '單層樹脂盤', spec: '18mm', shade: 'A3', stock: 5, category: 'PMMA' },
  
  // --- Zirconia: Senteri ---
  { brand: 'Senteri', model: '4D Pro', spec: '14mm', shade: 'BL3', stock: 1, category: 'Zirconia' },
  { brand: 'Senteri', model: '4D Pro', spec: '14mm', shade: 'A1', stock: 1, category: 'Zirconia' },
  { brand: 'Senteri', model: '4D Pro', spec: '20mm', shade: 'A1', stock: 2, category: 'Zirconia' },
  { brand: 'Senteri', model: '4D Pro', spec: '20mm', shade: 'A2', stock: 4, category: 'Zirconia' },
  { brand: 'Senteri', model: '4D Pro', spec: '20mm', shade: 'A3', stock: 2, category: 'Zirconia' },
  { brand: 'Senteri', model: '4D Pro', spec: '20mm', shade: '0M3', stock: 1, category: 'Zirconia' },
  { brand: 'Senteri', model: '4D Pro', spec: '20mm', shade: 'B1', stock: 2, category: 'Zirconia' },
  { brand: 'Senteri', model: '4D Pro', spec: '20mm', shade: 'B2', stock: 2, category: 'Zirconia' },
  { brand: 'Senteri', model: 'SHT ML', spec: '14mm', shade: 'BL3', stock: 1, category: 'Zirconia' },
  { brand: 'Senteri', model: 'SHT ML', spec: '14mm', shade: 'A1', stock: 1, category: 'Zirconia' },
  { brand: 'Senteri', model: 'SHT ML', spec: '20mm', shade: 'A2', stock: 2, category: 'Zirconia' },
  
  // --- Zirconia: Adite ---
  { brand: '愛迪特', model: '絢彩 Flash', spec: '14mm', shade: '0M1', stock: 1, category: 'Zirconia' },
  { brand: '愛迪特', model: '絢彩 Flash', spec: '18mm', shade: '0M2', stock: 1, category: 'Zirconia' },
  { brand: '愛迪特', model: '絢彩 Flash', spec: '18mm', shade: '0M3', stock: 1, category: 'Zirconia' },
  { brand: '愛迪特', model: '絢彩 Flash', spec: '18mm', shade: 'A1', stock: 2, category: 'Zirconia' },
  { brand: '愛迪特', model: '絢彩 Flash', spec: '18mm', shade: 'A2', stock: 2, category: 'Zirconia' },
  { brand: '愛迪特', model: '絢彩 Flash', spec: '18mm', shade: 'A3', stock: 1, category: 'Zirconia' },
  { brand: '愛迪特', model: '絢彩 Flash', spec: '18mm', shade: 'B1', stock: 1, category: 'Zirconia' },
  { brand: '愛迪特', model: '絢彩 Flash', spec: '18mm', shade: 'B3', stock: 1, category: 'Zirconia' },

  // --- Zirconia: Hengxing ---
  { brand: '恆星', model: '快燒', spec: '16mm', shade: 'A1', stock: 1, category: 'Zirconia' },
  { brand: '恆星', model: '快燒', spec: '16mm', shade: 'A3', stock: 1, category: 'Zirconia' },
  { brand: '恆星', model: '快燒', spec: '16mm', shade: 'B1', stock: 1, category: 'Zirconia' },
  { brand: '恆星', model: 'TT AIR', spec: '14mm', shade: 'BL4', stock: 1, category: 'Zirconia' },

  // --- Glass Ceramics ---
  { brand: 'Senteri', model: '玻璃陶瓷', spec: 'HT', shade: 'BL2', stock: 15, category: 'Glass' },
  { brand: 'Senteri', model: '玻璃陶瓷', spec: 'HT', shade: 'B1', stock: 15, category: 'Glass' },
  { brand: '愛迪特', model: '玻璃陶瓷', spec: 'HT', shade: 'A1', stock: 15, category: 'Glass' },
  { brand: '愛迪特', model: '玻璃陶瓷', spec: 'HT', shade: 'A3', stock: 15, category: 'Glass' },
  { brand: '愛迪特', model: '玻璃陶瓷', spec: 'LT', shade: 'A1', stock: 5, category: 'Glass' },
  { brand: '愛迪特', model: '玻璃陶瓷', spec: 'LT', shade: 'A3', stock: 5, category: 'Glass' },
  { brand: 'Amber', model: 'Mill', spec: 'C14', shade: 'BL3', stock: 17, category: 'Glass' },
];

const STATUS_STEPS = ['Received', 'Design', 'Milling/Print', 'Sinter/Cure', 'Glaze/Polish', 'QC', 'Delivered'];

// 內建材料類別（不可刪除），其餘類別由使用者新增並存在 Firestore settings.customCategories
// key 用於 material.category 欄位（必須英文以維持與舊資料相容）
// label 為顯示名稱; unit 為庫存單位; deduct 為建立工單時自動扣的數量
const BUILTIN_CATEGORIES = [
  { key: 'Zirconia', label: '氧化鋯', unit: '盤', deduct: 0.05 },
  { key: 'Glass',    label: '玻璃陶瓷', unit: '顆', deduct: 1 },
  { key: 'PMMA',     label: 'PMMA',  unit: '片', deduct: 1 },
];
const BUILTIN_CATEGORY_KEYS = BUILTIN_CATEGORIES.map(c => c.key);

// --- Helper Functions ---
const getFormattedDate = (date) => date.toISOString().split('T')[0];
const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

// --- Components ---

const StatusBadge = ({ status }) => {
  const colors = {
    'Received': 'bg-gray-100 text-gray-800',
    'Design': 'bg-blue-100 text-blue-800',
    'Milling/Print': 'bg-yellow-100 text-yellow-800',
    'Sinter/Cure': 'bg-orange-100 text-orange-800',
    'Glaze/Polish': 'bg-purple-100 text-purple-800',
    'QC': 'bg-pink-100 text-pink-800',
    'Delivered': 'bg-green-100 text-green-800',
  };
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${colors[status] || 'bg-gray-100'}`}>
      {status}
    </span>
  );
};

export default function DentalLabApp() {
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('cases'); 
  const [cases, setCases] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [backups, setBackups] = useState([]);
  const [clinics, setClinics] = useState(['橙蒔 / 黃文龍']); // Default clinic
  const [customCategories, setCustomCategories] = useState([]); // 使用者自訂的材料類別
  const [showNewCaseModal, setShowNewCaseModal] = useState(false);
  const [showAddClinic, setShowAddClinic] = useState(false);
  const [newClinicName, setNewClinicName] = useState('');
  const [showManageCategories, setShowManageCategories] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategoryUnit, setNewCategoryUnit] = useState('片');
  const [loading, setLoading] = useState(true);
  const [selectedBackup, setSelectedBackup] = useState(null);
  
  // Case Filter State
  const [showCompleted, setShowCompleted] = useState(false);

  // Edit Case State
  const [showEditCaseModal, setShowEditCaseModal] = useState(false);
  const [editingCase, setEditingCase] = useState(null);

  // Filter States for Inventory
  const [invCategory, setInvCategory] = useState('Zirconia');
  const [invBrandFilter, setInvBrandFilter] = useState('All');
  const [invSpecFilter, setInvSpecFilter] = useState('All');

  // Add Material State
  const [showAddMaterialModal, setShowAddMaterialModal] = useState(false);
  const [newMaterial, setNewMaterial] = useState({
    category: 'Zirconia', // Zirconia, Glass, PMMA
    brand: '',
    model: '',
    shade: '',
    spec: '', // Thickness for Zirc/PMMA, or Type for Glass
    stock: 1
  });

  // New Case Form State
  const [newCase, setNewCase] = useState({
    patient: '',
    doctor: '橙蒔 / 黃文龍',
    type: 'Fixed',
    item: 'Crown',
    teeth: '',
    unitCount: 1,
    shade: '',
    materialId: '',
    materialType: 'Zirconia',
    deliveryDate: getFormattedDate(addDays(new Date(), 7)),
    notes: '',
    tech: '黃文龍',
  });

  // --- Authentication ---
  useEffect(() => {
  // 不需要自動登入，等使用者點擊按鈕
  const unsubscribe = onAuthStateChanged(auth, setUser);
  return () => unsubscribe();
}, []);

  // --- Data Sync ---
  useEffect(() => {
    if (!user) return;
    setLoading(true);

    const casesRef = collection(db, 'artifacts', appId, 'public', 'data', 'cases');
    const materialsRef = collection(db, 'artifacts', appId, 'public', 'data', 'inventory');
    const backupsRef = collection(db, 'artifacts', appId, 'public', 'data', 'backups');
    const settingsRef = doc(db, 'artifacts', appId, 'public', 'data', 'settings', 'general');

    const unsubCases = onSnapshot(casesRef, (snapshot) => {
      setCases(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (err) => console.error("Cases error", err));

    const unsubMaterials = onSnapshot(materialsRef, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      
      if (data.length === 0) {
        INITIAL_MATERIALS.forEach(async (m) => {
          await addDoc(materialsRef, m);
        });
      } else {
        setMaterials(data);
      }
    }, (err) => console.error("Materials error", err));

    const unsubBackups = onSnapshot(query(backupsRef), (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        data.sort((a, b) => b.id.localeCompare(a.id)); 
        setBackups(data);
    });

    const unsubSettings = onSnapshot(settingsRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.clinics) setClinics(data.clinics);
        if (Array.isArray(data.customCategories)) setCustomCategories(data.customCategories);
      } else {
        setDoc(settingsRef, { clinics: ['橙蒔 / 黃文龍'], customCategories: [] });
      }
    });

    setLoading(false);

    return () => {
      unsubCases();
      unsubMaterials();
      unsubBackups();
      unsubSettings();
    };
  }, [user]);

  // --- Auto Backup ---
  useEffect(() => {
    if (!user || cases.length === 0 || materials.length === 0) return;
    const checkAndCreateBackup = async () => {
      const today = getFormattedDate(new Date());
      const backupRef = doc(db, 'artifacts', appId, 'public', 'data', 'backups', today);
      try {
        const docSnap = await getDoc(backupRef);
        if (!docSnap.exists()) {
          await setDoc(backupRef, {
            date: today,
            createdAt: new Date().toISOString(),
            casesSnapshot: cases,
            materialsSnapshot: materials
          });
        }
      } catch (e) { console.error("Backup failed", e); }
    };
    const timer = setTimeout(checkAndCreateBackup, 5000);
    return () => clearTimeout(timer);
  }, [user, cases.length, materials.length]);

  // --- Actions: Authentication ---
const handleLogin = async () => {
  try {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(auth, provider);  // ← 直接登入，沒有限制
  } catch (error) {
    console.error("登入失敗:", error.message);
    alert("登入失敗，請檢查網路連線");
  }
};

  // --- Actions: Settings ---
  const handleAddClinic = async () => {
    const name = newClinicName.trim();
    if (!name) return;
    if (clinics.includes(name)) {
      alert('此診所/醫師已存在。');
      return;
    }
    const updatedClinics = [...clinics, name];
    const settingsRef = doc(db, 'artifacts', appId, 'public', 'data', 'settings', 'general');
    await updateDoc(settingsRef, { clinics: updatedClinics });
    setNewClinicName('');
  };

  const handleDeleteClinic = async (name) => {
    if (!window.confirm(`確定要刪除「${name}」這個選項嗎？\n（既有工單上的醫師欄位不會被改動）`)) return;
    const updatedClinics = clinics.filter(c => c !== name);
    const settingsRef = doc(db, 'artifacts', appId, 'public', 'data', 'settings', 'general');
    await updateDoc(settingsRef, { clinics: updatedClinics });
  };

  // --- Actions: Material Categories ---
  const handleAddCategory = async () => {
    const label = newCategoryName.trim();
    const unit = (newCategoryUnit || '片').trim();
    if (!label) return;

    // key 用 label 本身（支援中文），唯一性比對忽略大小寫/前後空白
    const norm = (s) => s.toLowerCase();
    const allKeys = [...BUILTIN_CATEGORY_KEYS.map(norm), ...customCategories.map(c => norm(c.key))];
    const allLabels = [...BUILTIN_CATEGORIES.map(c => norm(c.label)), ...customCategories.map(c => norm(c.label))];
    if (allKeys.includes(norm(label)) || allLabels.includes(norm(label))) {
      alert('此類別已存在。');
      return;
    }

    const updated = [...customCategories, { key: label, label, unit, deduct: 1 }];
    const settingsRef = doc(db, 'artifacts', appId, 'public', 'data', 'settings', 'general');
    await updateDoc(settingsRef, { customCategories: updated });
    setNewCategoryName('');
    setNewCategoryUnit('片');
  };

  const handleDeleteCategory = async (key) => {
    if (BUILTIN_CATEGORY_KEYS.includes(key)) {
      alert('內建類別無法刪除。');
      return;
    }
    const used = materials.some(m => m.category === key);
    const msg = used
      ? `「${key}」目前還有庫存材料使用此類別。\n刪除後這些材料仍會保留在資料庫，但不會出現在任何分頁中。\n確定刪除？`
      : `確定要刪除「${key}」類別嗎？`;
    if (!window.confirm(msg)) return;

    const updated = customCategories.filter(c => c.key !== key);
    const settingsRef = doc(db, 'artifacts', appId, 'public', 'data', 'settings', 'general');
    await updateDoc(settingsRef, { customCategories: updated });

    // 如果目前正在檢視的分頁就是被刪除的類別，切回氧化鋯
    if (invCategory === key) setInvCategory('Zirconia');
  };

  // 合併內建 + 自訂 類別
  const getAllCategories = () => [...BUILTIN_CATEGORIES, ...customCategories];
  const getCategoryMeta = (key) => {
    return getAllCategories().find(c => c.key === key) || { key, label: key, unit: '片', deduct: 1 };
  };

  // --- Actions: Cases ---
  const handleCreateCase = async () => {
    if (!user) return;
    const casesRef = collection(db, 'artifacts', appId, 'public', 'data', 'cases');
    
    // For Guide, force material to placeholder
    const finalMaterialId = newCase.type === 'Guide' ? '3dp-placeholder' : newCase.materialId;

    const createdCase = {
      ...newCase,
      materialId: finalMaterialId,
      status: 'Received',
      receivedDate: getFormattedDate(new Date()), 
      startDate: getFormattedDate(new Date()),
      redoCount: 0,
      qc: '',
      createdAt: serverTimestamp()
    };
    
    await addDoc(casesRef, createdCase);
    setShowNewCaseModal(false);
    
    // Deduct stock if applicable (依顆數比例扣庫存)
    if (finalMaterialId && finalMaterialId !== '3dp-placeholder') {
      const material = materials.find(m => m.id === finalMaterialId);
      if (material) {
        const perUnit = getCategoryMeta(material.category).deduct || 0;
        const units = Math.max(1, Number(newCase.unitCount) || 1);
        const deductAmount = perUnit * units;
        if (deductAmount > 0) {
            const matRef = doc(db, 'artifacts', appId, 'public', 'data', 'inventory', material.id);
            const newStock = Math.max(0, Number((material.stock - deductAmount).toFixed(2)));
            await updateDoc(matRef, { stock: newStock });
        }
      }
    }
    
    setNewCase({
      patient: '', doctor: '橙蒔 / 黃文龍', type: 'Fixed', item: 'Crown',
      teeth: '', unitCount: 1, shade: '', materialId: '', materialType: 'Zirconia',
      deliveryDate: getFormattedDate(addDays(new Date(), 7)),
      notes: '', tech: '黃文龍'
    });
  };

  const handleEditCase = (caseData) => {
    setEditingCase({ ...caseData });
    setShowEditCaseModal(true);
  };

  const handleUpdateCase = async () => {
    if (!editingCase) return;
    const caseRef = doc(db, 'artifacts', appId, 'public', 'data', 'cases', editingCase.id);
    
    // Remove id from data object before saving
    const { id, ...dataToUpdate } = editingCase;
    
    await updateDoc(caseRef, dataToUpdate);
    setShowEditCaseModal(false);
    setEditingCase(null);
  };

  const handleDeleteCase = async (id) => {
    if (window.confirm("確定要刪除此工單嗎？此操作無法復原。")) {
       await deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'cases', id));
    }
  };

  const updateStatus = async (id, newStatus) => {
    const caseRef = doc(db, 'artifacts', appId, 'public', 'data', 'cases', id);
    await updateDoc(caseRef, { status: newStatus });
  };

  const handleQC = async (id, passed) => {
    const caseRef = doc(db, 'artifacts', appId, 'public', 'data', 'cases', id);
    const currentCase = cases.find(c => c.id === id);
    if (passed) {
      await updateDoc(caseRef, { status: 'Delivered', qc: user.displayName || 'Manager' });
    } else {
      await updateDoc(caseRef, { 
        status: 'Design', 
        redoCount: (currentCase.redoCount || 0) + 1, 
        notes: (currentCase.notes || '') + ' [REDO: QC Failed]' 
      });
    }
  };

  // --- Actions: Inventory ---
  const updateStock = async (id, delta) => {
    const mat = materials.find(m => m.id === id);
    if (mat) {
      const matRef = doc(db, 'artifacts', appId, 'public', 'data', 'inventory', id);
      const newStock = Math.max(0, Number((mat.stock + delta).toFixed(2)));
      await updateDoc(matRef, { stock: newStock });
    }
  };

  const handleAddMaterial = async () => {
    if (!newMaterial.brand || !newMaterial.model || !newMaterial.shade) return;

    const addAmount = Number(newMaterial.stock) || 0;
    // 檢查是否已存在相同規格 (category + brand + model + spec + shade)
    const norm = (s) => (s || '').toString().trim().toLowerCase();
    const existing = materials.find(m =>
      m.category === newMaterial.category &&
      norm(m.brand) === norm(newMaterial.brand) &&
      norm(m.model) === norm(newMaterial.model) &&
      norm(m.spec) === norm(newMaterial.spec) &&
      norm(m.shade) === norm(newMaterial.shade)
    );

    if (existing) {
      const ok = window.confirm(
        `庫存中已有相同規格的「${existing.brand} ${existing.model} ${existing.spec} ${existing.shade}」(目前 ${existing.stock})。\n要把 +${addAmount} 加到這筆紀錄上嗎？\n\n(取消的話則維持原樣，不會建立新紀錄)`
      );
      if (ok) {
        const matRef = doc(db, 'artifacts', appId, 'public', 'data', 'inventory', existing.id);
        const newStock = Number((existing.stock + addAmount).toFixed(2));
        await updateDoc(matRef, { stock: newStock });
      } else {
        return;
      }
    } else {
      const materialsRef = collection(db, 'artifacts', appId, 'public', 'data', 'inventory');
      await addDoc(materialsRef, {
        ...newMaterial,
        stock: addAmount
      });
    }

    setShowAddMaterialModal(false);
    setNewMaterial({ category: 'Zirconia', brand: '', model: '', shade: '', spec: '', stock: 1 });
  };

  const handleDeleteMaterial = async (mat) => {
    if (!mat) return;
    const ok = window.confirm(
      `確定要刪除這筆庫存紀錄嗎？\n\n${mat.brand} ${mat.model} ${mat.spec} ${mat.shade}\n目前庫存: ${mat.stock}\n\n此操作無法復原。`
    );
    if (!ok) return;
    await deleteDoc(doc(db, 'artifacts', appId, 'public', 'data', 'inventory', mat.id));
  };

  // --- Render Helpers ---
  const getFilteredCases = () => {
    let filtered = [...cases];
    
    // 1. Filter completed if needed
    if (!showCompleted) {
        filtered = filtered.filter(c => c.status !== 'Delivered');
    }
    
    // 2. Sort by deliveryDate descending
    filtered.sort((a, b) => {
        const dateA = new Date(a.deliveryDate);
        const dateB = new Date(b.deliveryDate);
        return dateB - dateA; // Descending
    });

    return filtered;
  };

  const getFilteredMaterials = () => {
    return materials.filter(m => {
      if (m.category !== invCategory) return false;
      if (invBrandFilter !== 'All' && m.brand !== invBrandFilter) return false;
      if (invSpecFilter !== 'All' && m.spec !== invSpecFilter) return false;
      return true;
    });
  };

  const getGroupedMaterials = (filtered) => {
    const groups = {};
    filtered.forEach(m => {
      if (!groups[m.brand]) groups[m.brand] = {};
      if (!groups[m.brand][m.model]) groups[m.brand][m.model] = [];
      groups[m.brand][m.model].push(m);
    });
    return groups;
  };

  const getUniqueBrands = (category) => {
    return ['All', ...new Set(materials.filter(m => m.category === category).map(m => m.brand))];
  };

  const getUniqueSpecs = (category) => {
    return ['All', ...new Set(materials.filter(m => m.category === category).map(m => m.spec))];
  };

  const getItemOptions = (type) => {
    if (type === 'Fixed') return ['Crown', 'Bridge', 'Inlay/Onlay', 'Veneer', 'Implant', 'Temp', 'Mock up'];
    if (type === 'BPS') return ['上顎', '下顎', '全口', 'Try-in'];
    if (type === 'Guide') return ['Superline', 'Osstem'];
    return [];
  };

  const handleTypeChange = (e) => {
      const type = e.target.value;
      let newItem = '';
      let newMaterialType = '';
      // Guide defaults to 3DP type but logic handles hiding the dropdown
      if (type === 'Fixed') { newItem = 'Crown'; newMaterialType = 'Zirconia'; }
      else if (type === 'BPS') { newItem = '全口'; newMaterialType = 'PMMA'; }
      else if (type === 'Guide') { newItem = 'Superline'; newMaterialType = '3DP'; }

      setNewCase({
          ...newCase, type, item: newItem, materialType: newMaterialType, materialId: '', shade: type === 'Guide' ? 'N/A' : '',
      });
  };

  // --- Smart Material Options ---
  const getAvailableMaterials = (caseData = newCase) => {
    // 1. Category Filter
    let filtered = materials.filter(m => {
        if (caseData.type === 'Fixed') return m.category === caseData.materialType;
        if (caseData.type === 'BPS') {
            return m.category === 'PMMA';
        }
        return false;
    });

    // 2. Shade Filter (Conditional)
    if (caseData.shade && caseData.shade.trim() !== '') {
        const query = caseData.shade.trim().toUpperCase();
        const matches = filtered.filter(m => m.shade.toUpperCase() === query || m.shade.toUpperCase().includes(query));
        if (matches.length > 0) {
            filtered = matches;
        }
    }

    // 3. Sort Alphabetically
    return filtered.sort((a, b) => {
        const nameA = `${a.brand} ${a.model} ${a.spec} ${a.shade}`;
        const nameB = `${b.brand} ${b.model} ${b.spec} ${b.shade}`;
        return nameA.localeCompare(nameB, 'zh-Hant');
    });
  };

  // Format material label for display (table & current selection hint)
  const getMaterialLabel = (caseData) => {
    if (!caseData) return '-';
    if (caseData.materialId === '3dp-placeholder') return '3D Print';
    const m = materials.find(x => x.id === caseData.materialId);
    if (m) return `${m.brand} ${m.model} ${m.spec} ${m.shade}`;
    // Fallback to materialType label if no specific item picked
    const typeMap = { Zirconia: '氧化鋯', Glass: '玻璃陶瓷', PMMA: 'PMMA', '3DP': '3D列印' };
    return typeMap[caseData.materialType] || (caseData.materialType || '未指定');
  };

  // Stats
  const stats = useMemo(() => {
    return {
      activeCases: cases.filter(c => c.status !== 'Delivered').length,
      urgent: cases.filter(c => c.status !== 'Delivered' && new Date(c.deliveryDate) <= new Date(new Date().setDate(new Date().getDate() + 2))).length,
      redoRate: cases.length > 0 ? ((cases.filter(c => (c.redoCount || 0) > 0).length / cases.length) * 100).toFixed(1) : 0,
      lowStock: materials.filter(m => m.stock < 1).length
    };
  }, [cases, materials]);

  // --- Views ---

  if (!user) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
        <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center">
          <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
            <Activity className="text-white w-8 h-8" />
          </div>
          <h1 className="text-2xl font-bold text-slate-800 mb-2">龍哥 Lab 雲端管理系統</h1>
          <p className="text-slate-500 mb-8">請登入以存取即時訂單與庫存資料</p>
          <button onClick={handleLogin} className="w-full bg-white border border-slate-300 text-slate-700 font-semibold py-3 px-4 rounded-lg flex items-center justify-center gap-3 hover:bg-slate-50 transition-all shadow-sm">
             <div className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold">G</div>
             使用 Google 帳號登入
          </button>
        </div>
      </div>
    );
  }

  if (activeTab === 'history' && selectedBackup) {
    return (
       <div className="min-h-screen bg-slate-50 p-8">
         <div className="max-w-7xl mx-auto">
           <button onClick={() => setSelectedBackup(null)} className="mb-4 text-blue-600 flex items-center gap-1 hover:underline">
             &larr; 返回歷史列表
           </button>
           <h2 className="text-2xl font-bold mb-6 text-slate-800">備份檢視: {selectedBackup.date}</h2>
           <div className="grid grid-cols-2 gap-8">
             <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
               <h3 className="font-bold mb-4 border-b pb-2">當日案件快照</h3>
               <div className="max-h-[500px] overflow-y-auto"><table className="w-full text-sm"><thead><tr className="text-left text-slate-500"><th>病患</th><th>項目</th><th>狀態</th></tr></thead><tbody>{selectedBackup.casesSnapshot?.map((c, idx) => (<tr key={idx} className="border-b border-slate-50"><td className="py-2">{c.patient}</td><td>{c.item}</td><td>{c.status}</td></tr>))}</tbody></table></div>
             </div>
             <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
               <h3 className="font-bold mb-4 border-b pb-2">當日庫存快照</h3>
               <div className="max-h-[500px] overflow-y-auto space-y-2">{selectedBackup.materialsSnapshot?.map((m, idx) => (<div key={idx} className="flex justify-between text-sm p-2 bg-slate-50 rounded"><span>{m.brand} {m.model} {m.shade}</span><span className="font-bold">數量: {m.stock}</span></div>))}</div>
             </div>
           </div>
         </div>
       </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans">
      {/* Top Navigation */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center gap-4">
              <div className="bg-blue-600 text-white p-2 rounded-lg">
                <Activity size={24} />
              </div>
              <h1 className="text-xl font-bold text-slate-800">龍哥假牙進度追蹤 <span className="text-xs font-normal bg-blue-100 text-blue-800 px-2 py-0.5 rounded ml-2">第一版</span></h1>
            </div>
            <div className="flex items-center gap-2">
               {['cases', 'inventory', 'history'].map((tab) => (
                 <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === tab ? 'bg-blue-50 text-blue-700' : 'text-slate-600 hover:bg-slate-100'}`}>
                   {tab === 'cases' ? '案件進度' : tab === 'inventory' ? '材料庫存' : '歷史備份'}
                 </button>
               ))}
               <button onClick={() => signOut(auth)} className="ml-4 p-2 text-slate-400 hover:text-slate-600" title="登出"><User size={20} /></button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        
        {/* Statistics Cards */}
        {activeTab === 'cases' && (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100">
              <div className="flex justify-between items-center"><div><p className="text-sm text-slate-500">進行中案件</p><p className="text-2xl font-bold text-slate-800">{stats.activeCases}</p></div><ClipboardList className="text-blue-500" /></div>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100">
              <div className="flex justify-between items-center"><div><p className="text-sm text-slate-500">2日內交件 (急)</p><p className="text-2xl font-bold text-red-600">{stats.urgent}</p></div><Clock className="text-red-500" /></div>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100">
              <div className="flex justify-between items-center"><div><p className="text-sm text-slate-500">庫存不足項目</p><p className="text-2xl font-bold text-amber-600">{stats.lowStock}</p></div><Package className="text-amber-500" /></div>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100">
              <div className="flex justify-between items-center"><div><p className="text-sm text-slate-500">本月重做率</p><p className="text-2xl font-bold text-slate-800">{stats.redoRate}%</p></div><TrendingUp className="text-green-500" /></div>
            </div>
          </div>
        )}

        {/* --- CASES TAB --- */}
        {activeTab === 'cases' && (
          <div>
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-4">
                <h2 className="text-lg font-semibold text-slate-800">案件列表</h2>
                {/* Filter Toggle */}
                <button 
                  onClick={() => setShowCompleted(!showCompleted)}
                  className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${showCompleted ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
                >
                  {showCompleted ? <Eye size={16} /> : <EyeOff size={16} />}
                  {showCompleted ? '隱藏已完成' : '顯示已完成'}
                </button>
              </div>
              <button onClick={() => setShowNewCaseModal(true)} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium"><Plus size={16} /> 新增案件</button>
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-left text-sm text-slate-600">
                  <thead className="bg-slate-50 border-b border-slate-200 text-slate-800 uppercase text-xs font-bold tracking-wider">
                    <tr>
                      {/* 縮減 padding，限制最小寬度 */}
                      <th className="px-4 py-3 align-top min-w-[120px]">病患 / 醫師</th>

                      <th className="px-4 py-3 align-top">項目 / 牙位</th>

                      {/* 備註欄位：寬度設為 auto 或較大比例，給予足夠空間 */}
                      <th className="px-4 py-3 align-top w-1/3 min-w-[200px]">備註</th>

                      {/* 交件日：強制不換行，縮減 padding */}
                      <th className="px-2 py-3 align-top whitespace-nowrap cursor-pointer flex items-center gap-1">交件日 <span className="text-slate-400">↓</span></th>

                      {/* 狀態：強制不換行，縮減 padding */}
                      <th className="px-2 py-3 align-top whitespace-nowrap">狀態</th>

                      <th className="px-4 py-3 align-top text-right">操作</th>

                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {getFilteredCases().map((c) => {
                       const materialLabel = getMaterialLabel(c);

                       return (
                      <tr key={c.id} className={`hover:bg-slate-50 transition-colors ${c.status === 'Delivered' ? 'bg-slate-50 opacity-75' : ''}`}>
                        {/* 病患與醫師：分兩行顯示 */}
                        <td className="px-4 py-3 align-top">
                            <div className="font-bold text-slate-900">{c.patient}</div>
                            <div className="text-xs text-slate-500 mt-1">{c.doctor}</div>
                        </td>

                        <td className="px-4 py-3 align-top">
                            <div className="font-medium">{c.item}{(c.unitCount > 1) ? <span className="ml-1 text-xs text-slate-500">× {c.unitCount} 顆</span> : null}</div>
                            <div className="text-xs text-slate-500">牙位: {c.teeth}</div>
                            <div className="text-xs text-blue-700 mt-1 font-medium">
                              材料: {materialLabel}{c.shade ? `  ·  比色: ${c.shade}` : ''}
                            </div>
                            {c.redoCount > 0 && <span className="text-xs text-red-500 font-bold">重做 {c.redoCount}次</span>}
                        </td>
                        
                        {/* 備註：使用 line-clamp-2 限制兩行，whitespace-normal 允許換行 */}
                        <td className="px-4 py-3 align-top">
                            <div className="text-sm text-slate-600 whitespace-normal line-clamp-2 min-w-[160px]" title={c.notes}>
                                {c.notes || '-'}
                            </div>
                        </td>

                        {/* 交件日：不換行，縮減 padding */}
                        <td className="px-2 py-3 align-top whitespace-nowrap">
                            <div className={`${new Date(c.deliveryDate) < new Date() ? 'text-red-600 font-bold' : ''}`}>{c.deliveryDate}</div>
                        </td>

                        {/* 狀態：不換行，縮減 padding */}
                        <td className="px-2 py-3 align-top whitespace-nowrap">
                            <StatusBadge status={c.status} />
                        </td>

                        <td className="px-4 py-3 align-top text-right">
                           <div className="flex gap-2 items-center justify-end">
                             {c.status === 'QC' ? (
                               <div className="flex gap-1">
                                 <button onClick={() => handleQC(c.id, true)} className="text-green-600 hover:bg-green-50 p-1 rounded" title="QC Pass"><CheckCircle2 size={18} /></button>
                                 <button onClick={() => handleQC(c.id, false)} className="text-red-600 hover:bg-red-50 p-1 rounded" title="QC Fail (Redo)"><XCircle size={18} /></button>
                               </div>
                             ) : c.status !== 'Delivered' ? (
                               <button onClick={() => { const currentIndex = STATUS_STEPS.indexOf(c.status); if (currentIndex < STATUS_STEPS.length - 1) { updateStatus(c.id, STATUS_STEPS[currentIndex + 1]); } }} className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-xs font-medium">下一步 <ChevronRight size={14} /></button>
                             ) : null}
                             
                             <div className="h-4 w-px bg-slate-300 mx-1"></div>
                             
                             <button onClick={() => handleEditCase(c)} className="text-slate-400 hover:text-blue-600 p-1 rounded" title="編輯">
                               <Edit2 size={16} />
                             </button>
                             <button onClick={() => handleDeleteCase(c.id)} className="text-slate-400 hover:text-red-600 p-1 rounded" title="刪除">
                               <Trash2 size={16} />
                             </button>
                           </div>
                        </td>
                      </tr>
                    )})}
                    {getFilteredCases().length === 0 && (<tr><td colSpan="7" className="text-center py-8 text-slate-400">目前沒有符合條件的案件。</td></tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* --- INVENTORY TAB --- */}
        {activeTab === 'inventory' && (
          <div>
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
              <h2 className="text-lg font-semibold text-slate-800">材料庫存管理</h2>
              <div className="flex gap-2 bg-white p-1 rounded-lg border border-slate-200 flex-wrap">
                {getAllCategories().map(cat => (
                  <button
                    key={cat.key}
                    onClick={() => { setInvCategory(cat.key); setInvBrandFilter('All'); setInvSpecFilter('All'); }}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${invCategory === cat.key ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-600 hover:bg-slate-50'}`}
                  >
                    {cat.label}
                  </button>
                ))}
                <button
                  onClick={() => setShowManageCategories(!showManageCategories)}
                  className="px-3 py-2 text-sm font-medium rounded-md text-blue-600 hover:bg-blue-50 flex items-center gap-1"
                  title="管理材料類別"
                >
                  <Settings size={14} /> 類別
                </button>
              </div>
              <button
                onClick={() => setShowAddMaterialModal(true)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-medium ml-auto"
              >
                <Plus size={16} /> 新增材料
              </button>
            </div>

            {/* 材料類別管理面板 */}
            {showManageCategories && (
              <div className="mb-6 p-4 bg-slate-50 border border-slate-200 rounded-lg">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-sm font-semibold text-slate-700">材料類別管理</h3>
                  <button onClick={() => setShowManageCategories(false)} className="text-slate-400 hover:text-slate-600 text-sm">收合</button>
                </div>
                <div className="space-y-1 max-h-48 overflow-y-auto mb-3">
                  {getAllCategories().map(cat => {
                    const isBuiltin = BUILTIN_CATEGORY_KEYS.includes(cat.key);
                    return (
                      <div key={cat.key} className="flex justify-between items-center bg-white px-3 py-2 rounded text-sm border border-slate-100">
                        <div className="flex items-center gap-2">
                          <span className="font-medium">{cat.label}</span>
                          <span className="text-xs text-slate-400">單位: {cat.unit} ・ 每筆扣 {cat.deduct}</span>
                          {isBuiltin && <span className="text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded">內建</span>}
                        </div>
                        {!isBuiltin && (
                          <button onClick={() => handleDeleteCategory(cat.key)} className="text-red-500 hover:text-red-700 p-1" title="刪除此類別">
                            <Trash2 size={14} />
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className="flex gap-2 items-end flex-wrap">
                  <div className="flex-1 min-w-[150px]">
                    <label className="block text-xs text-slate-600 mb-1">新類別名稱</label>
                    <input
                      type="text"
                      placeholder="例如: PEEK、高彈性樹脂盤"
                      value={newCategoryName}
                      onChange={(e) => setNewCategoryName(e.target.value)}
                      className="w-full border border-slate-300 rounded-lg p-2 text-sm"
                    />
                  </div>
                  <div className="w-24">
                    <label className="block text-xs text-slate-600 mb-1">庫存單位</label>
                    <input
                      type="text"
                      placeholder="片"
                      value={newCategoryUnit}
                      onChange={(e) => setNewCategoryUnit(e.target.value)}
                      className="w-full border border-slate-300 rounded-lg p-2 text-sm"
                    />
                  </div>
                  <button onClick={handleAddCategory} className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm">新增類別</button>
                </div>
                <div className="mt-2 text-[11px] text-slate-500">
                  ※ 新類別預設「每筆工單扣 1 個單位」。內建類別（氧化鋯/玻璃陶瓷/PMMA）無法刪除。
                </div>
              </div>
            )}

            {/* Sub Filters */}
            <div className="flex gap-4 mb-6 bg-slate-100 p-4 rounded-lg items-center">
              <Filter size={18} className="text-slate-500" />
              <select 
                value={invBrandFilter}
                onChange={(e) => setInvBrandFilter(e.target.value)}
                className="bg-white border border-slate-300 rounded-md px-3 py-1.5 text-sm"
              >
                {getUniqueBrands(invCategory).map(b => <option key={b} value={b}>{b === 'All' ? '所有品牌' : b}</option>)}
              </select>

              {(invCategory === 'Zirconia' || invCategory === 'Glass') && (
                 <select 
                   value={invSpecFilter}
                   onChange={(e) => setInvSpecFilter(e.target.value)}
                   className="bg-white border border-slate-300 rounded-md px-3 py-1.5 text-sm"
                 >
                   {getUniqueSpecs(invCategory).map(s => <option key={s} value={s}>{s === 'All' ? '所有規格/厚度' : s}</option>)}
                 </select>
              )}
              
              <span className="text-xs text-blue-600 font-bold ml-auto flex items-center gap-1">
                  <AlertCircle size={14}/> 注意: 庫存單位為「{getCategoryMeta(invCategory).unit}」
                  {invCategory === 'Glass' && '（1盒=5顆）'}
              </span>
            </div>

            {/* Grouped View */}
            <div className="space-y-6">
              {Object.entries(getGroupedMaterials(getFilteredMaterials())).map(([brand, models]) => (
                <div key={brand} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                  <div className="bg-slate-50 px-6 py-3 border-b border-slate-200 flex items-center gap-2">
                    <Layers size={18} className="text-blue-500"/>
                    <h3 className="font-bold text-slate-800">{brand}</h3>
                  </div>
                  
                  <div className="p-6 grid grid-cols-1 gap-8">
                    {Object.entries(models).map(([model, items]) => (
                      <div key={model}>
                        <h4 className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-3 border-b border-slate-100 pb-1">{model}</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
                          {items.sort((a,b) => a.shade.localeCompare(b.shade)).map(m => (
                            <div key={m.id} className={`relative p-3 rounded-lg border ${m.stock < 2 ? 'border-red-200 bg-red-50' : 'border-slate-200 bg-white'} hover:shadow-md transition-shadow group`}>
                               <button
                                 onClick={() => handleDeleteMaterial(m)}
                                 className="absolute top-1 right-1 text-slate-300 hover:text-red-600 opacity-0 group-hover:opacity-100 transition-opacity p-1"
                                 title="刪除此筆庫存紀錄"
                               >
                                 <Trash2 size={12} />
                               </button>
                               <div className="flex justify-between items-start mb-2">
                                  <span className="font-bold text-slate-800 text-lg">{m.shade}</span>
                                  <div className="flex flex-col items-end pr-4">
                                      <span className="text-[10px] text-slate-400 bg-slate-100 px-1 rounded">{m.spec}</span>
                                  </div>
                               </div>
                               <div className="flex items-center justify-between mt-2">
                                  <span className={`text-sm font-medium ${m.stock < 2 ? 'text-red-600' : 'text-slate-600'}`}>數量: {m.stock}</span>
                                  <div className="flex gap-1">
                                      <button onClick={() => updateStock(m.id, -(getCategoryMeta(invCategory).deduct || 1))} className="w-6 h-6 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center text-slate-600 text-xs">-</button>
                                      <button onClick={() => updateStock(m.id, (getCategoryMeta(invCategory).deduct || 1))} className="w-6 h-6 rounded-full bg-blue-50 hover:bg-blue-100 flex items-center justify-center text-blue-600 text-xs">+</button>
                                  </div>
                               </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              
              {Object.keys(getGroupedMaterials(getFilteredMaterials())).length === 0 && (
                  <div className="text-center py-12 text-slate-400 bg-slate-50 rounded-xl border border-dashed border-slate-300">
                      沒有符合篩選條件的材料
                  </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* --- NEW CASE MODAL --- */}
      {showNewCaseModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-slate-100 flex justify-between items-center">
              <h3 className="text-xl font-bold text-slate-800">新增工單</h3>
              <button onClick={() => setShowNewCaseModal(false)} className="text-slate-400 hover:text-slate-600"><XCircle size={24} /></button>
            </div>
            
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">患者姓名</label>
                  <input type="text" value={newCase.patient} onChange={(e) => setNewCase({...newCase, patient: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">診所/醫師</label>
                  <div className="flex gap-2">
                    <select 
                      value={newCase.doctor}
                      onChange={(e) => setNewCase({...newCase, doctor: e.target.value})}
                      className="w-full border border-slate-300 rounded-lg p-2"
                    >
                      {clinics.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                    <button onClick={() => setShowAddClinic(!showAddClinic)} className="bg-blue-100 text-blue-600 p-2 rounded-lg hover:bg-blue-200" title="管理診所/醫師"><Plus size={20} /></button>
                  </div>
                  {showAddClinic && (
                    <div className="mt-2 p-3 bg-slate-50 border border-slate-200 rounded-lg space-y-2">
                      <div className="text-xs font-medium text-slate-600">目前清單</div>
                      <div className="space-y-1 max-h-40 overflow-y-auto">
                        {clinics.map(c => (
                          <div key={c} className="flex justify-between items-center bg-white px-2 py-1 rounded text-sm border border-slate-100">
                            <span>{c}</span>
                            <button onClick={() => handleDeleteClinic(c)} className="text-red-500 hover:text-red-700 p-1" title="刪除此選項">
                              <Trash2 size={14} />
                            </button>
                          </div>
                        ))}
                        {clinics.length === 0 && <div className="text-xs text-slate-400 px-2 py-1">尚無任何選項</div>}
                      </div>
                      <div className="flex gap-2 pt-1">
                        <input type="text" placeholder="輸入: 診所 / 醫師" value={newClinicName} onChange={(e) => setNewClinicName(e.target.value)} className="border border-slate-300 rounded-lg p-2 text-sm flex-1" />
                        <button onClick={handleAddClinic} className="bg-green-600 text-white px-3 rounded-lg text-sm">新增</button>
                        <button onClick={() => setShowAddClinic(false)} className="bg-slate-200 text-slate-700 px-3 rounded-lg text-sm">完成</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">類型 </label>
                  <select value={newCase.type} onChange={handleTypeChange} className="w-full border border-slate-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500">
                    <option value="Fixed">固定假牙 (Fixed)</option>
                    <option value="BPS">全口活動假牙 (BPS)</option>
                    <option value="Guide">手術導板 (Guide)</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">交付日期 (預設7天)</label>
                  <input type="date" value={newCase.deliveryDate} onChange={(e) => setNewCase({...newCase, deliveryDate: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500" />
                </div>
              </div>

              <div className="grid grid-cols-12 gap-3">
                {/* 品項 */}
                <div className="col-span-12 sm:col-span-4">
                  <label className="block text-sm font-medium text-slate-700 mb-1">品項</label>
                  <select value={newCase.item} onChange={(e) => setNewCase({...newCase, item: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2">
                    {getItemOptions(newCase.type).map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </select>
                </div>

                {/* 牙位 - Fixed / Guide */}
                {!['BPS'].includes(newCase.type) && (
                  <div className="col-span-7 sm:col-span-4">
                    <label className="block text-sm font-medium text-slate-700 mb-1">牙位</label>
                    <input
                      type="text"
                      placeholder="例如: 11, 21"
                      value={newCase.teeth}
                      onChange={(e) => setNewCase({...newCase, teeth: e.target.value})}
                      className="w-full border border-slate-300 rounded-lg p-2"
                    />
                  </div>
                )}

                {/* 顆數 - 只在 Fixed 顯示 */}
                {newCase.type === 'Fixed' && (
                  <div className="col-span-5 sm:col-span-2">
                    <label className="block text-sm font-medium text-slate-700 mb-1" title="影響扣庫存的顆數">顆數</label>
                    <input
                      type="number"
                      min="1"
                      step="1"
                      value={newCase.unitCount}
                      onChange={(e) => setNewCase({...newCase, unitCount: Math.max(1, parseInt(e.target.value, 10) || 1)})}
                      className="w-full border border-slate-300 rounded-lg p-2 text-center"
                    />
                  </div>
                )}

                {/* 比色 - Hidden for Guide */}
                {newCase.type !== 'Guide' && (
                  <div className="col-span-12 sm:col-span-2">
                    <label className="block text-sm font-medium text-slate-700 mb-1">比色</label>
                    <input
                      type="text"
                      placeholder="A2"
                      value={newCase.shade}
                      onChange={(e) => setNewCase({...newCase, shade: e.target.value})}
                      className="w-full border border-slate-300 rounded-lg p-2"
                    />
                  </div>
                )}
              </div>

              {/* Material Selection - Hidden for Guide */}
              {newCase.type !== 'Guide' && (
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">使用材料 ( {newCase.shade || '全部'})</label>
                    <div className="flex gap-2 mb-2">
                        {newCase.type === 'Fixed' && (
                            <div className="flex gap-2 text-sm">
                               <button onClick={() => setNewCase({...newCase, materialType: 'Zirconia'})} className={`px-3 py-1 rounded-full ${newCase.materialType === 'Zirconia' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>氧化鋯</button>
                               <button onClick={() => setNewCase({...newCase, materialType: 'Glass'})} className={`px-3 py-1 rounded-full ${newCase.materialType === 'Glass' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>玻璃陶瓷</button>
                               <button onClick={() => setNewCase({...newCase, materialType: '3DP'})} className={`px-3 py-1 rounded-full ${newCase.materialType === '3DP' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>3D列印</button>
                            </div>
                        )}
                        {/* New buttons for BPS */}
                        {newCase.type === 'BPS' && (
                            <div className="flex gap-2 text-sm">
                               <button onClick={() => setNewCase({...newCase, materialType: 'PMMA'})} className={`px-3 py-1 rounded-full ${newCase.materialType === 'PMMA' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>PMMA (-1)</button>
                               <button onClick={() => setNewCase({...newCase, materialType: '3DP'})} className={`px-3 py-1 rounded-full ${newCase.materialType === '3DP' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>3DP (No Stock)</button>
                            </div>
                        )}
                    </div>
                    
                    <select
                      value={newCase.materialId}
                      onChange={(e) => setNewCase({...newCase, materialId: e.target.value})}
                      className="w-full border border-slate-300 rounded-lg p-2"
                    >
                      <option value="">選擇材料規格...</option>
                      {(newCase.materialType === '3DP' || newCase.type === 'Guide') && (
                          <option value="3dp-placeholder">3D Printing</option>
                      )}
                      {getAvailableMaterials().map(m => (
                        <option key={m.id} value={m.id} disabled={m.stock <= 0}>
                          {m.brand} {m.model} {m.spec} {m.shade} (庫存: {m.stock})
                        </option>
                      ))}
                    </select>
                    {/* 扣庫存預覽 */}
                    {newCase.materialId && newCase.materialId !== '3dp-placeholder' && (() => {
                      const m = materials.find(x => x.id === newCase.materialId);
                      if (!m) return null;
                      const meta = getCategoryMeta(m.category);
                      const units = Math.max(1, Number(newCase.unitCount) || 1);
                      const deduct = Number((meta.deduct * units).toFixed(2));
                      return (
                        <div className="mt-2 text-xs text-blue-700 bg-blue-50 border border-blue-100 rounded px-2 py-1">
                          建立後將扣庫存：{meta.deduct} {meta.unit} × {units} 顆 = <b>{deduct} {meta.unit}</b>（剩餘 {Math.max(0, Number((m.stock - deduct).toFixed(2)))}）
                        </div>
                      );
                    })()}
                  </div>
              )}

              

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">備註 / QC重點</label>
                <textarea value={newCase.notes} onChange={(e) => setNewCase({...newCase, notes: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2 h-20" placeholder="例如：接觸點要緊、邊緣要深..."></textarea>
              </div>
            </div>
            
            <div className="p-6 border-t border-slate-100 flex justify-end gap-3">
              <button onClick={() => setShowNewCaseModal(false)} className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg">取消</button>
              <button onClick={handleCreateCase} className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium">建立工單</button>
            </div>
          </div>
        </div>
      )}

      {/* --- EDIT CASE MODAL --- */}
      {showEditCaseModal && editingCase && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-slate-100 flex justify-between items-center">
              <h3 className="text-xl font-bold text-slate-800">編輯工單 (#{editingCase.id})</h3>
              <button onClick={() => setShowEditCaseModal(false)} className="text-slate-400 hover:text-slate-600"><XCircle size={24} /></button>
            </div>
            
            <div className="p-6 space-y-4">
               {/* Simplified edit fields - focusing on metadata correction */}
               <div className="grid grid-cols-2 gap-4">
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">患者姓名</label>
                   <input type="text" value={editingCase.patient} onChange={(e) => setEditingCase({...editingCase, patient: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2" />
                 </div>
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">診所/醫師</label>
                   <div className="flex gap-2">
                     <select value={editingCase.doctor} onChange={(e) => setEditingCase({...editingCase, doctor: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2">
                       {!clinics.includes(editingCase.doctor) && editingCase.doctor && (
                         <option value={editingCase.doctor}>{editingCase.doctor}（已移除）</option>
                       )}
                       {clinics.map(c => <option key={c} value={c}>{c}</option>)}
                     </select>
                     <button onClick={() => setShowAddClinic(!showAddClinic)} className="bg-blue-100 text-blue-600 p-2 rounded-lg hover:bg-blue-200" title="管理診所/醫師"><Plus size={20} /></button>
                   </div>
                   {showAddClinic && (
                     <div className="mt-2 p-3 bg-slate-50 border border-slate-200 rounded-lg space-y-2">
                       <div className="text-xs font-medium text-slate-600">目前清單</div>
                       <div className="space-y-1 max-h-40 overflow-y-auto">
                         {clinics.map(c => (
                           <div key={c} className="flex justify-between items-center bg-white px-2 py-1 rounded text-sm border border-slate-100">
                             <span>{c}</span>
                             <button onClick={() => handleDeleteClinic(c)} className="text-red-500 hover:text-red-700 p-1" title="刪除此選項">
                               <Trash2 size={14} />
                             </button>
                           </div>
                         ))}
                         {clinics.length === 0 && <div className="text-xs text-slate-400 px-2 py-1">尚無任何選項</div>}
                       </div>
                       <div className="flex gap-2 pt-1">
                         <input type="text" placeholder="輸入: 診所 / 醫師" value={newClinicName} onChange={(e) => setNewClinicName(e.target.value)} className="border border-slate-300 rounded-lg p-2 text-sm flex-1" />
                         <button onClick={handleAddClinic} className="bg-green-600 text-white px-3 rounded-lg text-sm">新增</button>
                         <button onClick={() => setShowAddClinic(false)} className="bg-slate-200 text-slate-700 px-3 rounded-lg text-sm">完成</button>
                       </div>
                     </div>
                   )}
                 </div>
               </div>

               <div className="grid grid-cols-3 gap-4">
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">類型</label>
                   <select value={editingCase.type} onChange={(e) => {
                     const type = e.target.value;
                     let materialType = editingCase.materialType;
                     if (type === 'Fixed' && !['Zirconia','Glass','3DP'].includes(materialType)) materialType = 'Zirconia';
                     else if (type === 'BPS' && !['PMMA','3DP'].includes(materialType)) materialType = 'PMMA';
                     else if (type === 'Guide') materialType = '3DP';
                     setEditingCase({...editingCase, type, materialType});
                   }} className="w-full border border-slate-300 rounded-lg p-2">
                     <option value="Fixed">Fixed</option>
                     <option value="BPS">BPS</option>
                     <option value="Guide">Guide</option>
                   </select>
                 </div>
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">品項</label>
                   <select value={editingCase.item} onChange={(e) => setEditingCase({...editingCase, item: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2">
                      {getItemOptions(editingCase.type).map(opt => <option key={opt} value={opt}>{opt}</option>)}
                   </select>
                 </div>
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">交件日</label>
                   <input type="date" value={editingCase.deliveryDate} onChange={(e) => setEditingCase({...editingCase, deliveryDate: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2" />
                 </div>
               </div>

               <div className="grid grid-cols-3 gap-4">
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">牙位</label>
                   <input type="text" value={editingCase.teeth} onChange={(e) => setEditingCase({...editingCase, teeth: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2" />
                 </div>
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">顆數</label>
                   <input type="number" min="1" step="1" value={editingCase.unitCount ?? 1} onChange={(e) => setEditingCase({...editingCase, unitCount: Math.max(1, parseInt(e.target.value, 10) || 1)})} className="w-full border border-slate-300 rounded-lg p-2" />
                 </div>
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">比色</label>
                   <input type="text" value={editingCase.shade || ''} onChange={(e) => setEditingCase({...editingCase, shade: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2" />
                 </div>
               </div>

               {/* 材料選擇 - Guide 類型不顯示 */}
               {editingCase.type !== 'Guide' && (
                 <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">
                     使用材料
                     <span className="ml-2 text-xs text-slate-500 font-normal">
                       (目前: {getMaterialLabel(editingCase)})
                     </span>
                   </label>
                   <div className="flex gap-2 mb-2">
                     {editingCase.type === 'Fixed' && (
                       <div className="flex gap-2 text-sm">
                         <button type="button" onClick={() => setEditingCase({...editingCase, materialType: 'Zirconia', materialId: ''})} className={`px-3 py-1 rounded-full ${editingCase.materialType === 'Zirconia' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>氧化鋯</button>
                         <button type="button" onClick={() => setEditingCase({...editingCase, materialType: 'Glass', materialId: ''})} className={`px-3 py-1 rounded-full ${editingCase.materialType === 'Glass' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>玻璃陶瓷</button>
                         <button type="button" onClick={() => setEditingCase({...editingCase, materialType: '3DP', materialId: '3dp-placeholder'})} className={`px-3 py-1 rounded-full ${editingCase.materialType === '3DP' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>3D列印</button>
                       </div>
                     )}
                     {editingCase.type === 'BPS' && (
                       <div className="flex gap-2 text-sm">
                         <button type="button" onClick={() => setEditingCase({...editingCase, materialType: 'PMMA', materialId: ''})} className={`px-3 py-1 rounded-full ${editingCase.materialType === 'PMMA' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>PMMA</button>
                         <button type="button" onClick={() => setEditingCase({...editingCase, materialType: '3DP', materialId: '3dp-placeholder'})} className={`px-3 py-1 rounded-full ${editingCase.materialType === '3DP' ? 'bg-blue-600 text-white' : 'bg-gray-100'}`}>3DP</button>
                       </div>
                     )}
                   </div>

                   <select
                     value={editingCase.materialId || ''}
                     onChange={(e) => setEditingCase({...editingCase, materialId: e.target.value})}
                     className="w-full border border-slate-300 rounded-lg p-2"
                   >
                     <option value="">選擇材料規格...</option>
                     {editingCase.materialType === '3DP' && (
                       <option value="3dp-placeholder">3D Printing</option>
                     )}
                     {/* 確保目前選用的材料就算庫存為 0 也能顯示 */}
                     {editingCase.materialId && editingCase.materialId !== '3dp-placeholder' &&
                       !getAvailableMaterials(editingCase).some(m => m.id === editingCase.materialId) &&
                       (() => {
                         const cur = materials.find(m => m.id === editingCase.materialId);
                         return cur ? (
                           <option value={cur.id}>
                             {cur.brand} {cur.model} {cur.spec} {cur.shade} (目前選用，庫存: {cur.stock})
                           </option>
                         ) : null;
                       })()
                     }
                     {getAvailableMaterials(editingCase).map(m => (
                       <option key={m.id} value={m.id}>
                         {m.brand} {m.model} {m.spec} {m.shade} (庫存: {m.stock})
                       </option>
                     ))}
                   </select>
                 </div>
               )}

               <div>
                 <label className="block text-sm font-medium text-slate-700 mb-1">備註</label>
                 <textarea value={editingCase.notes} onChange={(e) => setEditingCase({...editingCase, notes: e.target.value})} className="w-full border border-slate-300 rounded-lg p-2 h-20"></textarea>
               </div>

               <div className="bg-amber-50 p-3 rounded text-xs text-amber-800 border border-amber-100">
                  注意：在編輯模式下變更「材料」不會自動調整庫存。若需更換材料並同時扣庫存，建議刪除此工單並重新建立。
               </div>
            </div>

            <div className="p-6 border-t border-slate-100 flex justify-end gap-3">
              <button onClick={() => setShowEditCaseModal(false)} className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg">取消</button>
              <button onClick={handleUpdateCase} className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium">儲存變更</button>
            </div>
          </div>
        </div>
      )}

      {/* --- ADD MATERIAL MODAL --- */}
      {showAddMaterialModal && (
         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
           <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
             <div className="p-6 border-b border-slate-100 flex justify-between items-center">
               <h3 className="text-xl font-bold text-slate-800">新增庫存材料</h3>
               <button onClick={() => setShowAddMaterialModal(false)} className="text-slate-400 hover:text-slate-600"><XCircle size={24} /></button>
             </div>
             <div className="p-6 space-y-4">
                <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">材料類別</label>
                   <select
                     value={newMaterial.category}
                     onChange={(e) => setNewMaterial({...newMaterial, category: e.target.value})}
                     className="w-full border border-slate-300 rounded-lg p-2"
                   >
                     {getAllCategories().map(c => (
                       <option key={c.key} value={c.key}>{c.label}</option>
                     ))}
                   </select>
                   <div className="text-[11px] text-slate-400 mt-1">
                     沒有想要的類別？到庫存頁面點「類別」按鈕新增。
                   </div>
                </div>
                <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">
                     品牌 (Brand)
                     <span className="text-xs text-slate-400 font-normal ml-1">(可選既有或直接輸入新品牌)</span>
                   </label>
                   <input
                     type="text"
                     list="brand-options"
                     placeholder="例如: Senteri, 愛迪特"
                     value={newMaterial.brand}
                     onChange={(e) => setNewMaterial({...newMaterial, brand: e.target.value})}
                     className="w-full border border-slate-300 rounded-lg p-2"
                   />
                   <datalist id="brand-options">
                     {Array.from(new Set(
                       materials.filter(m => m.category === newMaterial.category).map(m => m.brand)
                     )).sort().map(b => (
                       <option key={b} value={b} />
                     ))}
                   </datalist>
                </div>
                <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">
                     型號 (Model)
                     <span className="text-xs text-slate-400 font-normal ml-1">(可選既有或直接輸入新型號)</span>
                   </label>
                   <input
                     type="text"
                     list="model-options"
                     placeholder="例如: 4D Pro, HT"
                     value={newMaterial.model}
                     onChange={(e) => setNewMaterial({...newMaterial, model: e.target.value})}
                     className="w-full border border-slate-300 rounded-lg p-2"
                   />
                   <datalist id="model-options">
                     {Array.from(new Set(
                       materials
                         .filter(m => m.category === newMaterial.category && (!newMaterial.brand || m.brand === newMaterial.brand))
                         .map(m => m.model)
                     )).sort().map(model => (
                       <option key={model} value={model} />
                     ))}
                   </datalist>
                </div>
                <div className="grid grid-cols-2 gap-4">
                   <div>
                     <label className="block text-sm font-medium text-slate-700 mb-1">顏色 (Shade)</label>
                     <input 
                       type="text" 
                       placeholder="A1, BL2..."
                       value={newMaterial.shade} 
                       onChange={(e) => setNewMaterial({...newMaterial, shade: e.target.value})} 
                       className="w-full border border-slate-300 rounded-lg p-2" 
                     />
                   </div>
                   <div>
                     <label className="block text-sm font-medium text-slate-700 mb-1">
                       {newMaterial.category === 'Glass' ? '規格 (如: Block)' : '厚度/規格 (如: 14mm)'}
                     </label>
                     <input
                       type="text"
                       value={newMaterial.spec}
                       onChange={(e) => setNewMaterial({...newMaterial, spec: e.target.value})}
                       className="w-full border border-slate-300 rounded-lg p-2"
                     />
                   </div>
                </div>
                <div>
                   <label className="block text-sm font-medium text-slate-700 mb-1">
                     初始數量 ({getCategoryMeta(newMaterial.category).unit}{newMaterial.category === 'Glass' ? ' (1盒填5)' : ''})
                   </label>
                   <input 
                     type="number" 
                     min="1"
                     value={newMaterial.stock} 
                     onChange={(e) => setNewMaterial({...newMaterial, stock: e.target.value})} 
                     className="w-full border border-slate-300 rounded-lg p-2" 
                   />
                </div>
             </div>
             <div className="p-6 border-t border-slate-100 flex justify-end gap-3">
               <button onClick={() => setShowAddMaterialModal(false)} className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg">取消</button>
               <button onClick={handleAddMaterial} className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium">新增入庫</button>
             </div>
           </div>
         </div>
      )}

    </div>
  );
}
